import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('pagos-universidades-padres'), data);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('pagos-universidades-padres'), { params: opciones.params });
  },
  async findOneComprobante(id, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos(`pagos-universidades-padres/${id}/comprobante`), opciones);
  },
};
